import React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import FormDrawerWrapper from '../../../features/components/FormDrawerWrapper'
import ExportAsCsvReportForm from './ExportAsCsvReportForm'

import { EXPORT_AS_CSV_REPORT } from '../../../constants/forms'

const ExportAsCsvReport = ({ dateRangeSelector, campaignsIds, level }) => {
  const { t } = useTranslation()

  return (
    <FormDrawerWrapper
      formName={EXPORT_AS_CSV_REPORT}
      title={t('Export csv report')}
      openButtonText={t('Export as CSV')}
    >
      <ExportAsCsvReportForm dateRangeSelector={dateRangeSelector} campaignsIds={campaignsIds} level={level} />
    </FormDrawerWrapper>
  )
}

ExportAsCsvReport.propTypes = {
  dateRangeSelector: PropTypes.func.isRequired,
  campaignsIds: PropTypes.array.isRequired,
  level: PropTypes.string.isRequired
}

export default ExportAsCsvReport
